<section>
<app-header></app-header>
<div class="imprint nav-text">
    <h1>{{ 'imprint.imprint' | translate }}</h1><br>
    <p><strong>Angaben gemäß § 5 TMG:</strong></p>
    <p>
        Michael Spari<br>
        Am Wolsbach 33<br>
        56244 Helferskirchen<br>
    </p><br>
    <p>
        <strong>{{ 'imprint.contact' | translate }}</strong><br>
        E-Mail: <a href="mailto:info@michaelspari.de">info(at)michaelspari.de</a>
    </p><br>
    <p><strong>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</strong></p>
    <p>
        Michael Spari<br>
        Am Wolsbach 33<br>
        56244 Helferskirchen<br>
    </p><br>
    <p><strong>{{ 'imprint.disclaimer' | translate }}</strong></p>
    <p>Diese Webseite dient ausschließlich zu Bewerbungszwecken.</p><br>
    <p><strong>Haftung für Links:</strong></p>
    <p>Diese Webseite enthält möglicherweise Links zu externen Webseiten Dritter, auf deren Inhalte ich keinen Einfluss habe. Daher kann ich für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p><br>
    
    <h1>{{ 'imprint.privacypolice' | translate }}</h1><br>
    <p><strong>1. Datenschutz auf einen Blick</strong></p>
    <p>Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und den Zweck der Verarbeitung von personenbezogenen Daten auf dieser Webseite auf.</p>
    <br>
    <p><strong>2. Verantwortliche Stelle</strong></p>
    <p>Verantwortlich für die Datenverarbeitung auf dieser Webseite ist:<br>
        Michael Spari<br>
        Am Wolsbach 33<br>
        56244 Helferskirchen<br>
        E-Mail: <a href="mailto:info@michaelspari.de">info(at)michaelspari.de</a>
    </p>
    <br>
    <p><strong>3. Erhebung und Speicherung personenbezogener Daten</strong></p>
    <p>Beim Besuch dieser Webseite werden keine personenbezogenen Daten erfasst, es sei denn, Sie nehmen aktiv Kontakt auf (z. B. per E-Mail).</p>
    <br>
    <p><strong>4. Ihre Rechte</strong></p>
    <p>Sie haben jederzeit das Recht auf Auskunft über Ihre gespeicherten Daten sowie ein Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung dieser Daten. Bitte wenden Sie sich dazu an die oben genannte verantwortliche Stelle.</p>
    <br>
    <p><strong>5. Sicherheit</strong></p>
    <p>Diese Webseite nutzt technische und organisatorische Sicherheitsmaßnahmen, um Ihre Daten gegen unbefugten Zugriff zu schützen.</p>
</div>
<!-- <app-footer></app-footer> -->
</section>